export default __webpack_public_path__ + "7b40da77f734d77b86199a71ea0e75e4.jpg";